import "../App.css";
import React from "react";

export function ErrorPage() {
  /* 장애일 때 렌더링 할 부분 */
  //let loadingPage = <h1> 로딩중.. </h1>;
  let loadingPage1 = (
    <h1>
      {" "}
      잘못된 접근 방법입니다. 접속 주소를 확인해 주세요. 직접적인 ip 주소 사용
      불가.{" "}
    </h1>
  );
  let content = loadingPage1;

  const params = new URLSearchParams(window.location.search);
  let message = params.get("message");

  if (message) {
    let str = "";
    if (message === "ERR_CONNECTION_REFUSED") {
      str = "서버접속이 일시적으로 제한됩니다. ";
    }
    let loadingPage2 = <h1>{str}</h1>;
    content = loadingPage2;
  }

  /* 선택한 content 렌더링 */
  return <div className="App">{content}</div>;
}

export default ErrorPage;
